// src/v2/pages/Reports/ReportSalaryLoanDeduction.js
import React from 'react';
import { GeneralMessage } from '../../../common/APICommon';
import { SalaryLoanDeductionReportModule } from '../../components/modules/Reports/ReportSalaryLoanDeduction/SalaryLoanDeductionModuleReport';
import { useSalaryLoanDeductionReport } from '../../hooks/useReportSalaryLoanDeduction';

const SalaryLoanDeductionReport = ({ isHideSideMenu }) => {
  const reportHook = useSalaryLoanDeductionReport();

  return (
    <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
      <div className="LeftSpace"></div>
      <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
        <SalaryLoanDeductionReportModule reportHook={reportHook} />
      </div>
      <GeneralMessage form={reportHook.showMessage} message={reportHook.message} isSuccess={reportHook.isSuccess} />
    </div>
  );
};

export default SalaryLoanDeductionReport;